import { PickEntity } from './base/PickEntity';
import { RaycastPicker } from './pick/RaycastPicker';
import { BoundsPicker } from './pick/BoundsPicker';
import { TabPicker } from './pick/TabPicker';
/**
 * @class away.pool.PickGroup
 */
var PickGroup = /** @class */ (function () {
    /**
     * //TODO
     *
     * @param materialClassGL
     */
    function PickGroup(view) {
        this._entityPool = new Object();
        this._view = view;
        this._raycastPickerPool = new RaycastPickerPool(this);
        this._boundsPickerPool = new BoundsPickerPool(this);
        this._tabPickerPool = PickGroup._tabPickerPool || (PickGroup._tabPickerPool = new TabPickerPool());
    }
    Object.defineProperty(PickGroup, "instancePool", {
        get: function () { return PickGroup._instancePool; },
        enumerable: true,
        configurable: true
    });
    ;
    PickGroup.clearAllInstances = function () {
        for (var key in this._instancePool) {
            this._instancePool[key].clearAll();
            delete this._instancePool[key];
        }
    };
    PickGroup.getInstance = function (view) {
        return this._instancePool[view.id] || (this._instancePool[view.id] = new PickGroup(view));
    };
    PickGroup.clearInstance = function (view) {
        var pickGroup = this._instancePool[view.id];
        if (pickGroup) {
            pickGroup.clearAll();
            delete this._instancePool[view.id];
        }
    };
    PickGroup.prototype.getAbstraction = function (entity) {
        return this._entityPool[entity.id] || (this._entityPool[entity.id] = new PickEntity(this._view, entity, this));
    };
    /**
     *
     * @param entity
     */
    PickGroup.prototype.clearAbstraction = function (entity) {
        delete this._entityPool[entity.id];
    };
    /**
     * Clears the resources used by the PickGroup.
     */
    PickGroup.prototype.clearAll = function () {
        //clear all entities associated with this pick group
        for (var key in this._entityPool)
            this._entityPool[key].onClear(null);
        this._raycastPickerPool.clearAll();
        this._boundsPickerPool.clearAll();
        this._tabPickerPool.clearAll();
    };
    PickGroup.prototype.getRaycastPicker = function (partition) {
        return this._raycastPickerPool.getAbstraction(partition);
    };
    PickGroup.prototype.getBoundsPicker = function (partition) {
        return this._boundsPickerPool.getAbstraction(partition);
    };
    PickGroup.prototype.getTabPicker = function (partition) {
        return this._tabPickerPool.getAbstraction(partition);
    };
    PickGroup._instancePool = new Object();
    return PickGroup;
}());
export { PickGroup };
var RaycastPickerPool = /** @class */ (function () {
    function RaycastPickerPool(pickGroup) {
        this._abstractionPool = new Object();
        this._pickGroup = pickGroup;
    }
    /**
     * //TODO
     *
     * @param entity
     * @returns EntityNode
     */
    RaycastPickerPool.prototype.getAbstraction = function (partition) {
        return (this._abstractionPool[partition.id] || (this._abstractionPool[partition.id] = new RaycastPicker(this._pickGroup, partition, this)));
    };
    /**
     *
     * @param entity
     */
    RaycastPickerPool.prototype.clearAbstraction = function (partition) {
        delete this._abstractionPool[partition.id];
    };
    /**
     * Clears the resources used by the RaycastPickerPool.
     */
    RaycastPickerPool.prototype.clearAll = function () {
        //clear all raycastpickers associated with this pool
        for (var key in this._abstractionPool)
            this._abstractionPool[key].onClear(null);
    };
    return RaycastPickerPool;
}());
var BoundsPickerPool = /** @class */ (function () {
    function BoundsPickerPool(pickGroup) {
        this._abstractionPool = new Object();
        this._pickGroup = pickGroup;
    }
    /**
     * //TODO
     *
     * @param entity
     * @returns EntityNode
     */
    BoundsPickerPool.prototype.getAbstraction = function (partition) {
        return (this._abstractionPool[partition.id] || (this._abstractionPool[partition.id] = new BoundsPicker(this._pickGroup, partition, this)));
    };
    /**
     *
     * @param entity
     */
    BoundsPickerPool.prototype.clearAbstraction = function (partition) {
        delete this._abstractionPool[partition.id];
    };
    /**
     * Clears the resources used by the BoundsPickerPool.
     */
    BoundsPickerPool.prototype.clearAll = function () {
        //clear all boundspickers associated with this pool
        for (var key in this._abstractionPool)
            this._abstractionPool[key].onClear(null);
    };
    return BoundsPickerPool;
}());
var TabPickerPool = /** @class */ (function () {
    function TabPickerPool() {
        this._abstractionPool = new Object();
    }
    /**
     * //TODO
     *
     * @param entity
     * @returns EntityNode
     */
    TabPickerPool.prototype.getAbstraction = function (partition) {
        return (this._abstractionPool[partition.id] || (this._abstractionPool[partition.id] = new TabPicker(partition, this)));
    };
    /**
     *
     * @param entity
     */
    TabPickerPool.prototype.clearAbstraction = function (partition) {
        delete this._abstractionPool[partition.id];
    };
    /**
     * Clears the resources used by the TabPickerPool.
     */
    TabPickerPool.prototype.clearAll = function () {
        //clear all tabpickers associated with this pool
        for (var key in this._abstractionPool)
            this._abstractionPool[key].onClear(null);
    };
    return TabPickerPool;
}());
